<template>
        <div>
                 <el-dialog
                        title="查看"
                        width="65%"
                        append-to-body
                        v-if="dialogVisible"
                        :fullscreen="dialogFull"
                        :close-on-click-modal="false"
                        :visible.sync="dialogVisible"
                        :destroy-on-close="true"
                        :before-close="handleClose"
                        v-loading="loading"

                >
                <template slot="title">
                        <div class="avue-crud__dialog__header">
                                <span class="el-dialog__title">
                                        详情
                                </span>
                                <i class="el-icon-full-screen" style="margin-right:20px;position:relative;top:-1px"  @click="dialogFull=!dialogFull"></i>
                                
                        </div>
                </template>
                        <!-- <detailFormInspection v-if="type==1" :isWatch="true" :form="form" :projectList.sync="projectList" :projectId.sync ="projectId" :cancelBtn="false"></detailFormInspection> -->
                        <detailFormMaintenance v-if="type==2" :form="form" :projectList.sync="projectList" :projectId.sync ="projectId" :cancelBtn="false"></detailFormMaintenance>
                        <addInspectionRecord2 
                        v-if="dialogVisible&&type==1"
                        :dialogVisible.sync="dialogVisible" 
                        
                        title="查看3"
                        operatorModel='view' 
                        :projectId="form.projectId"
                        :projectList='projectList'
                        :row='form'
                        ></addInspectionRecord2>
                        <ComprehensiveRecord v-if="type==3"  :row="form" model='view'></ComprehensiveRecord>
                </el-dialog>
        </div>
</template>
<script>
import {upkeepDetail,deviceinspecttasklist} from "@/api/crmedical/device/taskManagement";
import detailFormInspection from "@/components/device/deviceInspectionRecord/deviceInspectionRecord.vue"
import detailFormMaintenance from "@/components/device/deviceKeepRecord/maintenanceRecoderAdd.vue"
import ComprehensiveRecord  from "@/views/crmedical/comprehensiveInspect/record/recordForm.vue"
import addInspectionRecord2 from "@/components/device/deviceInspectionRecord/deviceInspect.vue"
import {taskGeneralDetail} from '@/api/crmedical/comprehensiveInspect/index.js'
export default {
        components:{detailFormInspection,detailFormMaintenance,ComprehensiveRecord,addInspectionRecord2},
        props:{
                projectList:{
                        type:Array,
                        default(){
                                return []
                        }
                }
        },
        data(){
                return{
                        loading:false,
                        form:{},
                        dialogVisible:false,
                        dialogFull:false,
                        
                        type:1,
                        projectId:'',

                }
        },
        methods:{
                openDialog(row,type,projectId){
                        this.initData(row.id,type);
                        this.projectId = projectId;
                        console.log(this.projectId)
                        this.type = type;
                        this.loading = true;
                        console.log("dianjiaxianqing")
                        
                },
                async initData(id,type){
                        if(type == 1){
                                await deviceinspecttasklist({id:id}).then(res=>{
                                        this.form = res.data;
                                        this.dialogVisible = true;
                                        console.log("接口获取form",this.form)
                                }).catch(err=>{
                                        this.loading = false;  
                                })
                        }else if(type == 2){
                                await upkeepDetail({id:id}).then(res=>{
                                        this.form = res.data;
                                        this.dialogVisible = true;
                                }).catch(err=>{
                                        this.loading = false;  
                                })
                        }else if(type == 3){
                                await taskGeneralDetail({id:id}).then(res=>{
                                        this.form = res.data
                                        this.dialogVisible = true
                                }).catch(err=>{
                                        this.loading = false;  
                                })
                        }
                        this.form.projectId = this.projectId; 
                        this.loading = false;
                }
        }
}
</script>